import LockTabTable from './LockTabTable'
export default LockTabTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/LockTab/LockTabTable/index.js